import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    gap: 20,
    maxWidth: '920px',
    padding: '32px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px',
    }
  },

  title: {
    fontWeight: 700,
    fontSize: '40px',
    lineHeight: '48px',
    textAlign: 'center',
  },

  description: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '24px',
    color: "rgba(0, 0, 0, 0.5)",
    textAlign: 'center',
    maxWidth: '664px',
  },

  button: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    width: '203px',
    height: '56px',
    whiteSpace: 'nowrap',

    "& svg": {
      marginLeft: 10
    }
  },

  img: {
    cursor: 'pointer',
  },

  watchVideoModal: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
      maxWidth: '912px',

      [theme.breakpoints.down('sm')]: {
        maxWidth: '456px'
      },
    }
  },
}))

export default useStyles
